import { KsService } from '@siclop/kstone-vue'

export class WorkScheduleTemplateService extends KsService {
  protected static mainUrl = '/work-schedule-templates'
}
